import { render, staticRenderFns } from "./UrgentClose.vue?vue&type=template&id=54e75c0e&"
import script from "./UrgentClose.vue?vue&type=script&lang=js&"
export * from "./UrgentClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports